import { getGroup, findGroups } from '../api'

export const loadGroupDetail = ({ state, commit }, uuid) => {
  return getGroup(uuid)
}

export const searchGroups = ({ state, commit }, {page, count}) => {
  return findGroups(page, count)
}



// WEBPACK FOOTER //
// ./src/app/group/vuex/actions.js